
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/beyondtrust-alternative",
      function () {
        return require("private-next-pages/compare/beyondtrust-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/beyondtrust-alternative"])
      });
    }
  